export default __webpack_public_path__ + "static/media/ndt-welds.995a9ea1.webp";